import { TAppFormError } from "../../../types/TAppFormError";
import Text from "../../atoms/form/Text";
import TableRow from "../../atoms/TableRow";
import Button from "../../atoms/Button";
import STButton from "../../../assets/styles/atoms/button.module.scss";
import STSingleTextWithButtonRow from "../../../assets/styles/molecules/formTableRow/singleTextWithButtonRow.module.scss";
import { ReactElement } from "react";
import AlartMessages from "../../atoms/AlartMessages";
import validateFormRow from "../../../utils/form/validateFormRow";

type Props<T> = {
  title: string;
  subTitle?: string;
  placeholder?: string;
  defaultValue?: string;
  required?: boolean;
  formKey: T;
  errors: TAppFormError<T>[];
  setErrors: (errors: TAppFormError<T>[]) => void;
  hundleOnChange: (value: string) => void;
  hundleButtonClick: () => void;
  buttonText: string | ReactElement;
  isDisplay?: boolean;
  canChange?: boolean;
  maxLength?: number;
  minLength?: number;
  pattern?: RegExp;
  patternText?: string;
};

const SingleTextWithButtonRow = <T,>({
  title,
  subTitle,
  placeholder,
  defaultValue,
  required = false,
  formKey,
  errors,
  setErrors,
  hundleOnChange,
  hundleButtonClick,
  buttonText,
  isDisplay = true,
  canChange = true,
  maxLength,
  minLength,
  pattern,
  patternText,
}: Props<T>) => {
  const hundleChange = (input: string) => {
    validateFormRow<T>({
      input,
      errors,
      setErrors,
      formKey,
      maxLength,
      minLength,
      pattern,
      patternText,
      required,
    });
    hundleOnChange(input);
  };

  if (!isDisplay) return <></>;
  return (
    <TableRow title={title} subTitle={subTitle} required={required}>
      <span>
        <Text
          className={
            canChange
              ? STSingleTextWithButtonRow.form
              : STSingleTextWithButtonRow.disable
          }
          name={title}
          defaultValue={defaultValue}
          placeholder={placeholder}
          onChange={(input) => hundleChange(input)}
        />
      </span>
      <Button
        className={`${STButton.primary} ${STSingleTextWithButtonRow.button} ${
          defaultValue === ""
            && STButton.disable
        }`}
        clickAction={() => hundleButtonClick()}
        text={<p>{buttonText}</p>}
      />
      {AlartMessages<T>({
        title: title,
        errors: errors,
        keys: [formKey],
      })}
    </TableRow>
  );
};

export default SingleTextWithButtonRow;
